module.exports = __webpack_public_path__ + "img/blue-diamond-solo.71eeb121.svg";